import { Button, DatePicker, Select } from "@ds/ds-snam/react";
import React, {  useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Input as TextInput } from "@ds/ds-snam/react";
import { dsDeselectHandler, dsPreSelectHandler, dsSelectHandler } from "shared/utils/dsComponentUtils";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { DsLayout, LANGUAGES, ResponseCode, ResponseStatus, RoutePath } from "shared/constants";
import { postPreBillingReport } from "net/prebilling";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { requestPristine } from "state/reducer/requestStatusSlice";
import { useDispatch, useSelector } from "react-redux";
import { buildPopUp } from "components/PopUp";
import { RootState } from "state/appStore";
import { IReportElement } from "dataModels/b2b";
const menuValuesDefaultIT:ISelectLabel[] = [
    {
        "id": "0",
        "label": "Chiuso con esito positivo",
        "value": "0"
    },
    {
        "id": "1",
        "label": "Failure To Take",
        "value": "1"
    },
    {
        "id": "2",
        "label": "Failure To Deliver",
        "value": "2"
    },
    {
        "id": "3",
        "label": "Annullato",
        "value": "3"
    }
]
const menuValuesDefaultEN:ISelectLabel[] = [
    {
        "id": "0",
        "label": "Closed with positive outcome",
        "value": "0"
    },
    {
        "id": "1",
        "label": "Failure To Take",
        "value": "1"
    },
    {
        "id": "2",
        "label": "Failure To Deliver",
        "value": "2"
    },
    {
        "id": "3",
        "label": "Canceled",
        "value": "3"
    }
]

const PreBillingForm:React.FC<{}> = ():JSX.Element=>{
    const { t, i18n } = useTranslation(["preBilling", "app"]);
    const { codeIup } = useParams();
    const location = useLocation();
    const [formData,setFormData]= useState(location.state.report);
    const [menuValues,setMenuValues] = useState<ISelectLabel[]|undefined>(undefined)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const lang: string = LANGUAGES.get(i18n.language)!.id!
    const isPercentageBioLngValid: boolean =
        formData.bioFlagDisabled !== false ||
        formData.percentageBioLng === undefined ||
        formData.percentageBioLng === null ||
        (Number.isFinite(formData.percentageBioLng) && formData.percentageBioLng >= 0 && formData.percentageBioLng <= 100);

    useEffect(()=>{
        if(menuValues!==undefined){
            console.log(location.state.report.supplyingResultId)
            switch (location.state.report.supplyingResultId) {
                case 0:
                    dsPreSelectHandler(menuValues, "0");
                    break;
                case 1:
                    dsPreSelectHandler(menuValues, "1");
                    break;
                case 2:
                    dsPreSelectHandler(menuValues, "2");
                    break;
                case 3:
                    dsPreSelectHandler(menuValues, "3");
                    break;
                default:
                    break;
            }
        }
    },[menuValues]);
    useEffect(()=>{
        setMenuValues(lang==='it'?menuValuesDefaultIT:menuValuesDefaultEN);
    },[])

    const saveData = () => {
        postPreBillingReport('update',formData)
        .then((response) => { 
            buildPopUp(dispatch,response,t,'Error','OK-422',t('preBilling.preBillingData.toast.0'),t('preBilling.preBillingData.toast.1'));
            navigate(RoutePath.PRE_BILLING_INFO);
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            dispatch(requestPristine());
        })
    }


    return (
        <>
            <p className="pageTitle">{t('preBilling.preBillingForm.titles.0')}</p>
            <div className="box" style={{ marginTop: '20px', background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-50, #EFF1F5)" }}>
                <div className="boxTitle" style={{ fontSize: '25px' }}>
                </div>
                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={5}>
                        <TextInput
                            inputPlaceholder=""
                            inputValue={formData.cost}//{formData![id as keyof ICheckListData] as string}
                            inputId=""//{id}
                            inputLabel={t('preBilling.preBillingForm.labels.0')}
                            inputDescription="€/Load"
                            input-event-type="single_character"
                            onInputChange={(inputEvent: Event) => {
                                let value = (inputEvent as CustomEvent).detail.input.value;
                                let currentFormData = formData;
                                currentFormData.cost=Number(value);
                                setFormData(currentFormData);
                            }
                            }
                        />
                    </Col>
                </Row>
                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={5}>
                        {menuValues &&
                            <Select
                                id="closureType"
                                selectId="closureType"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={menuValues?menuValues:[]}
                                menuLabel={t('preBilling.preBillingForm.labels.1')}
                                menuId="select-id"
                                isDisabled={false}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const supplyingResultId = (event as CustomEvent).detail.option;
                                    dsSelectHandler(menuValues as ISelectLabel[], supplyingResultId);
                                    let currentFormData = {...formData};
                                    currentFormData.supplyingResultId=Number(supplyingResultId.value);
                                    setFormData(currentFormData);
                                }}
                            ></Select>
                        }
                    </Col>
                </Row>
                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={5}>
                        <TextInput
                            inputPlaceholder=""
                            inputValue={formData.percentageBioLng !== undefined && formData.percentageBioLng !== null && Number.isFinite(formData.percentageBioLng) ? formData.percentageBioLng.toString() : ""}
                            inputId="percentageBioLng"
                            inputLabel={t('preBilling.preBillingForm.labels.2')}
                            inputDescription={isPercentageBioLngValid ? "%" : t('preBilling.preBillingForm.labels.3')}
                            inputStatus={isPercentageBioLngValid ? "default" : "error"}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            minValue={0}
                            maxValue={100}
                            isDisabled={formData.bioFlagDisabled !== false}
                            onInputChange={(inputEvent: Event) => {
                                if (formData.bioFlagDisabled !== false) {
                                    return;
                                }
                                const value: string = (inputEvent as CustomEvent).detail.input.value;
                                setFormData((previous: IReportElement) => ({
                                    ...previous,
                                    percentageBioLng: Number(value.replace(",", ".")),
                                }));
                            }}
                        />
                    </Col>
                </Row>
                
                
            </div>
            <Button
                style={{ float:'right',marginTop:'20px',marginLeft:'20px' }}
                id="backButton"
                buttonType="button"
                buttonUIVariant="primary"
                buttonSize="medium"
                buttonLabel={t('general.buttons.save', { ns: 'app' })}//"Salva"
                buttonIcon=""
                isDisabled={!isPercentageBioLngValid}
                onClickEvent={() => {
                    saveData();
                }}
            />
            <Button
                style={{ float:'right',marginTop:'20px' }}
                id="backButton"
                buttonType="button"
                buttonUIVariant="secondary"
                buttonSize="medium"
                buttonLabel={t('general.buttons.cancel', { ns: 'app' })}//"Annulla"
                buttonIcon=""
                isDisabled={false}
                onClickEvent={() => {
                    navigate(RoutePath.PRE_BILLING_INFO);
                }}
            />
        </>
    );
}
export default PreBillingForm;